import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    opened: { type: Boolean, default: false }
  }

  connect () {
    this.#setupStateSync()
  }

  disconnect () {
    document.body.classList.remove('overflow-hidden')
  }

  openedValueChanged (value) {
    if (value === true) {
      document.body.classList.add('overflow-hidden')
    } else {
      document.body.classList.remove('overflow-hidden')
    }

    this.#syncAria(value)
  }

  #setupStateSync () {
    const burgers = this.element.querySelectorAll('.navbar__burger')

    burgers.forEach(burger => {
      if (!burger.hasAttribute('aria-expanded')) {
        burger.setAttribute('aria-expanded', 'false')
      }

      burger.addEventListener('click', () => {
        requestAnimationFrame(() => {
          const wrapper = burger.closest('[data-controller*="dropdown"]')
          if (!wrapper) return

          const menu = wrapper.querySelector('[data-dropdown-target="menu"]')
          if (!menu) return

          const isOpen = !menu.classList.contains('hidden')
          this.openedValue = isOpen
        })
      })
    })
  }

  #syncAria (isOpen) {
    const burgers = this.element.querySelectorAll('.navbar__burger')

    burgers.forEach(burger => {
      burger.setAttribute('aria-expanded', isOpen.toString())
    })
  }
}
